import React from "react";
import { LocationImage } from "./components/location_image/location_image.jsx";
import { AppBodyContainer } from "wm_global";
import { AppFooter, Logo } from "pwm_global";
import { FAQ } from "./components/faq/faq.jsx";
import { Map } from "./components/map/map.jsx";
import { Address } from "./components/address/address.jsx";
import { DirectionsLink } from "./components/address/directions_link.jsx";
import { Hours } from "./components/hours/hours.jsx";
import { Title } from "./components/title/title.jsx";
import {
  Bootstrap5TabPanelsContainer,
  Bootstrap5TabItemsContainer,
  Bootstrap5TabPanel,
  Bootstrap5TabItem,
} from "../../../wm/components/whitelists_manager/ui/components/bootstrap5_tabs/bootstrap5_tabs.jsx";
import { ALL_SERVICES, PRINTING } from "./components/services/services.js";
import { PhoneNumber } from "./components/phone/phone.jsx";

export const App = ({ location }) => {
  return (
    <>
      <Header />
      <AppBodyContainer>
        <Title name={location.name} scanCopyFax={location.scanCopyFax} />

        {location.outOfOrder ? (
          <div className="my-4">
            <p className="ooo-text">
              This location is currently out of order. Sorry for the
              inconvenience.
            </p>
          </div>
        ) : null}

        <div className="row" id="about">
          <div className="col-12 col-md-9">
            <div className="mb-3">
              <p>{location.description}</p>
            </div>

            <Map name={location.name} address={location.address} />
          </div>

          <div className="col-12 col-md-3 mt-4 mt-md-0">
            <LocationImage url={location.photoUrl} />

            <div className="mt-1">
              <Address address={location.address} />
            </div>

            <div className="mt-1">
              <DirectionsLink name={location.name} address={location.address} />
            </div>

            {location.hours.useSupportHours == false ? (
              <div className="mt-1">
                <PhoneNumber />
              </div>
            ) : null}

            <div className="mt-3">
              <Hours hours={location.hours} />
            </div>
          </div>
        </div>

        {location.scanCopyFax ? (
          <div id="services" style={{ marginTop: "3rem" }}>
            <Bootstrap5TabItemsContainer>
              {ALL_SERVICES.map((option, idx) => {
                return (
                  <Bootstrap5TabItem
                    id={option.name}
                    idx={idx}
                    key={option.name}
                  >
                    <span className="service-option-tab-title">
                      {option.name}
                    </span>{" "}
                    {<option.icon />}
                  </Bootstrap5TabItem>
                );
              })}
            </Bootstrap5TabItemsContainer>

            <Bootstrap5TabPanelsContainer>
              {ALL_SERVICES.map((option, idx) => {
                return (
                  <Bootstrap5TabPanel
                    id={option.name}
                    idx={idx}
                    key={option.name}
                  >
                    {<option.component location={location} />}
                  </Bootstrap5TabPanel>
                );
              })}
            </Bootstrap5TabPanelsContainer>
          </div>
        ) : (
          <div id="services">
            <PRINTING.component location={location} />
          </div>
        )}

        <div id="faq" className="mt-5">
          <FAQ scanCopyFax={location.scanCopyFax} />
        </div>
      </AppBodyContainer>
      <AppFooter />
    </>
  );
};

const Header = () => (
  <div style={{ marginBottom: "2rem" }}>
    <header className="page-header d-flex justify-content-center justify-content-md-between">
      <div className="ps-md-5 pt-4">
        <Logo url="https://printwithme.com/" />
      </div>

      <nav className="d-none d-sm-flex align-items-center pe-md-4">
        <ul className="d-flex list-unstyled">
          <li>
            <a href="#about">About</a>
          </li>
          <li>
            <a href="#services">Services</a>
          </li>
          <li>
            <a href="#faq">FAQ</a>
          </li>
        </ul>
      </nav>
    </header>
  </div>
);
